import { render, staticRenderFns } from "./prc_set.vue?vue&type=template&id=a26f491a&scoped=true"
import script from "./prc_set.vue?vue&type=script&lang=js"
export * from "./prc_set.vue?vue&type=script&lang=js"
import style0 from "./prc_set.vue?vue&type=style&index=0&id=a26f491a&prod&lang=scss&scoped=true"
import style1 from "./prc_set.vue?vue&type=style&index=1&id=a26f491a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26f491a",
  null
  
)

export default component.exports